import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Mail } from '@mui/icons-material';
import ContactEmailDialog from './ContactEmailDialog';

interface ContactEmailButtonProps {
  contactId: string;
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'default';
  disabled?: boolean;
}

const ContactEmailButton: React.FC<ContactEmailButtonProps> = ({ 
  contactId, 
  size = 'small', 
  color = 'default',
  disabled = false
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Tooltip title="Compose email">
        <IconButton
          onClick={handleClick}
          size={size}
          color={color}
          disabled={disabled}
          sx={{
            ml: 0.5,
            '&:hover': {
              backgroundColor: 'action.hover',
            }
          }}
        >
          <Mail fontSize={size === 'small' ? 'small' : 'inherit'} />
        </IconButton>
      </Tooltip>
      
      <ContactEmailDialog
        open={dialogOpen}
        contactId={contactId}
        onClose={handleClose}
      />
    </>
  );
};

export default ContactEmailButton;